// THIS IS A GENERATED FILE, use `yarn codegen` to regenerate
/* tslint:disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AddressDetails = {
  __typename?: 'AddressDetails';
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

export type AddressResponse = {
  __typename?: 'AddressResponse';
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

export type BankAccount = {
  account: Scalars['String'];
  account_type: Scalars['String'];
  agency: Scalars['String'];
  bank_code: Scalars['String'];
  bank_name: Scalars['String'];
};

export type BankAccountDetailsInput = {
  account?: Maybe<Scalars['String']>;
  account_type?: Maybe<Scalars['String']>;
  agency?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
  bank_number?: Maybe<Scalars['String']>;
};

export type BankAccountResponse = {
  __typename?: 'BankAccountResponse';
  account?: Maybe<Scalars['String']>;
  account_type?: Maybe<Scalars['String']>;
  agency?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
  bank_number?: Maybe<Scalars['String']>;
};

export type BankDetails = {
  __typename?: 'BankDetails';
  account?: Maybe<Scalars['String']>;
  account_type?: Maybe<Scalars['String']>;
  agency?: Maybe<Scalars['String']>;
  bank_code?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
};

export type BankResponse = {
  __typename?: 'BankResponse';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type BankResponseWrapper = {
  __typename?: 'BankResponseWrapper';
  data?: Maybe<Array<BankResponse>>;
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type CcbResponse = {
  __typename?: 'CCBResponse';
  _id: Scalars['String'];
  ccb_url: Scalars['String'];
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  message?: Maybe<Scalars['String']>;
};

export type CreateOrderResponse = {
  __typename?: 'CreateOrderResponse';
  id?: Maybe<Scalars['String']>;
};

export type CreateOrderWrapper = {
  __typename?: 'CreateOrderWrapper';
  data?: Maybe<CreateOrderResponse>;
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type DocumentCheckResponse = {
  __typename?: 'DocumentCheckResponse';
  status: DocumentStatus;
};

export type DocumentDetails = {
  __typename?: 'DocumentDetails';
  debt_payment_receipt?: Maybe<Scalars['String']>;
  identification_back?: Maybe<Scalars['String']>;
  identification_front?: Maybe<Scalars['String']>;
  identification_type?: Maybe<Scalars['String']>;
  insurance?: Maybe<Scalars['String']>;
  insurance_receipt?: Maybe<Scalars['String']>;
  pay_slip?: Maybe<Scalars['String']>;
  payment_receipt?: Maybe<Scalars['String']>;
  proof_of_residence?: Maybe<Scalars['String']>;
};

export enum DocumentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  NotFound = 'NOT_FOUND',
  Onboard = 'ONBOARD',
  Prospect = 'PROSPECT',
  WhatsappActive = 'WHATSAPP_ACTIVE'
}

export type Documents = {
  path: Scalars['String'];
  type: Scalars['String'];
};

export type Employee = {
  __typename?: 'Employee';
  address?: Maybe<AddressDetails>;
  auth_id: Scalars['String'];
  bank_account?: Maybe<BankDetails>;
  cell_phone?: Maybe<Scalars['String']>;
  cpf: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  full_name: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
};

export type EmployeeDetailsInput = {
  bank_account?: Maybe<BankAccountDetailsInput>;
  base_salary?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  net_salary?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['String']>;
};

export type EmployeeResponse = {
  __typename?: 'EmployeeResponse';
  address?: Maybe<AddressResponse>;
  bank_account?: Maybe<BankAccountResponse>;
  cpf?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  message: Scalars['String'];
};

export type ErrorResponseLogin = {
  __typename?: 'ErrorResponseLogin';
  message: Scalars['String'];
};

export type FirstAccessResponse = {
  __typename?: 'FirstAccessResponse';
  access_token?: Maybe<Scalars['String']>;
  error?: Maybe<ErrorResponse>;
  expires_in?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  email: Scalars['String'];
  message: Scalars['String'];
  phone: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Installment = {
  __typename?: 'Installment';
  amortization?: Maybe<Scalars['Float']>;
  due_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  interest?: Maybe<Scalars['Float']>;
  iof?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
  payment_status?: Maybe<Scalars['String']>;
  principal_balance?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type InstallmentsResponse = {
  __typename?: 'InstallmentsResponse';
  payment_status: Scalars['String'];
  value: Scalars['Float'];
};

export type ListResponse = {
  __typename?: 'ListResponse';
  ccb_number: Scalars['String'];
  code: Scalars['Float'];
  corporation_name: Scalars['String'];
  created_at: Scalars['String'];
  id: Scalars['String'];
  installment_amount: Scalars['Float'];
  installment_value: Scalars['Float'];
  installments?: Maybe<Array<InstallmentsResponse>>;
  installments_total: Scalars['Float'];
  status: Scalars['String'];
  value: Scalars['Float'];
};

export type Loan = {
  __typename?: 'Loan';
  _id: Scalars['String'];
  another_reason?: Maybe<Scalars['String']>;
  ccb_number?: Maybe<Scalars['String']>;
  ccb_url?: Maybe<Scalars['String']>;
  code: Scalars['Float'];
  created_at: Scalars['String'];
  document?: Maybe<DocumentDetails>;
  employee: Employee;
  financed_value: Scalars['Float'];
  first_due: Scalars['String'];
  has_insurance: Scalars['Boolean'];
  installment_amount: Scalars['Float'];
  installment_value: Scalars['Float'];
  installments?: Maybe<Array<Installment>>;
  installments_total: Scalars['Float'];
  insurance_value: Scalars['Float'];
  monthly_interest_rate: Scalars['Float'];
  paid_date?: Maybe<Scalars['String']>;
  pmt: Scalars['Float'];
  reasons?: Maybe<Array<Scalars['String']>>;
  signed_date?: Maybe<Scalars['String']>;
  spread_total: Scalars['Float'];
  status: Scalars['String'];
  total_debt: Scalars['Float'];
  value: Scalars['Float'];
};

export type LoanWrapper = {
  __typename?: 'LoanWrapper';
  data?: Maybe<Loan>;
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  data?: Maybe<LoginResponseData>;
  error?: Maybe<ErrorResponseLogin>;
  success: Scalars['Boolean'];
};

export type LoginResponseData = {
  __typename?: 'LoginResponseData';
  access_token: Scalars['String'];
  expires_in: Scalars['String'];
};

export type MeResponse = {
  __typename?: 'MeResponse';
  company_name: Scalars['String'];
  corporation_cnpj: Scalars['String'];
  corporation_name: Scalars['String'];
  name: Scalars['String'];
  position?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelLoan: LoanWrapper;
  changePassword: ChangePasswordResponse;
  createOrder: CreateOrderWrapper;
  createPreRegistration: SuccessResponse;
  dataReview: SuccessResponse;
  firstAccess: FirstAccessResponse;
  forgotPassword: ForgotPasswordResponse;
  getSimulation: SimulationResponseWrapper;
  login: LoginResponse;
  orderConfirm: SuccessResponse;
  registerExternalLead: SuccessResponse;
  resetPassword: ResetPasswordResponse;
  sign: SuccessResponse;
  signCCB: SignCcbResponse;
  updateEmployee: SuccessResponse;
  updateOptOutShareData: SuccessResponse;
  updateOrder: CreateOrderResponse;
  updateOrderDocuments: SuccessResponse;
  updateOrderDocumentsV2: SuccessResponse;
};


export type MutationCancelLoanArgs = {
  id: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  confirm_password: Scalars['String'];
  cpf: Scalars['String'];
  new_password: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCreateOrderArgs = {
  another_reason: Scalars['String'];
  has_insurance: Scalars['Boolean'];
  installment_amount: Scalars['Float'];
  reasons: Array<Scalars['String']>;
  value: Scalars['Float'];
};


export type MutationCreatePreRegistrationArgs = {
  phone: Scalars['String'];
  pre_registration: PreRegistrationDetailsInput;
};


export type MutationDataReviewArgs = {
  bank_account: BankAccount;
  email: Scalars['String'];
  id: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationFirstAccessArgs = {
  confirm_password: Scalars['String'];
  cpf: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  cpf?: Maybe<Scalars['String']>;
  partner_pathname?: Maybe<Scalars['String']>;
};


export type MutationGetSimulationArgs = {
  has_insurance: Scalars['Boolean'];
  value: Scalars['Float'];
};


export type MutationLoginArgs = {
  cpf: Scalars['String'];
  password: Scalars['String'];
};


export type MutationOrderConfirmArgs = {
  id: Scalars['String'];
};


export type MutationRegisterExternalLeadArgs = {
  company: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  confirm_password: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSignArgs = {
  id: Scalars['String'];
  signature: Signature;
};


export type MutationSignCcbArgs = {
  fingerprint: Scalars['String'];
  id: Scalars['String'];
};


export type MutationUpdateEmployeeArgs = {
  employee: EmployeeDetailsInput;
};


export type MutationUpdateOptOutShareDataArgs = {
  id: Scalars['String'];
};


export type MutationUpdateOrderArgs = {
  another_reason: Scalars['String'];
  has_insurance: Scalars['Boolean'];
  id: Scalars['String'];
  installment_amount: Scalars['Float'];
  reasons: Array<Scalars['String']>;
  value: Scalars['Float'];
};


export type MutationUpdateOrderDocumentsArgs = {
  id: Scalars['String'];
  identification_back: Scalars['String'];
  identification_front: Scalars['String'];
  pay_slip: Scalars['String'];
  proof_of_residence: Scalars['String'];
};


export type MutationUpdateOrderDocumentsV2Args = {
  documents: Array<Documents>;
  id: Scalars['String'];
};

export type OptOutShareData = {
  __typename?: 'OptOutShareData';
  opt_out_share_data?: Maybe<Scalars['String']>;
};

export type OptOutShareDataResponse = {
  __typename?: 'OptOutShareDataResponse';
  data?: Maybe<OptOutShareData>;
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type PixBankAccountResponse = {
  __typename?: 'PixBankAccountResponse';
  account_branch: Scalars['String'];
  account_digit: Scalars['String'];
  account_number: Scalars['String'];
  account_type: Scalars['String'];
  bank_code: Scalars['String'];
  bank_name: Scalars['String'];
};

export type PixBankAccountWrapper = {
  __typename?: 'PixBankAccountWrapper';
  data?: Maybe<PixBankAccountResponse>;
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type PreRegistrationDetailsInput = {
  company_name?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  checkDocument: DocumentCheckResponse;
  getAll: Array<ListResponse>;
  getBanks: BankResponseWrapper;
  getCCBPdf: RenegotiationCcbDetailsResponse;
  getEmployee: EmployeeResponse;
  getLoanDetails: LoanWrapper;
  getMe: MeResponse;
  getOptOutShareData: OptOutShareDataResponse;
  getPreRegistration: Scalars['String'];
  getRelevantOrder: RelevantOrderResponse;
  getSimulationRange: SimulationRangeResponseWrapper;
  getStatistic: StatisticResponse;
  loadCcb: LoanWrapper;
  verifyPixKey: PixBankAccountWrapper;
};


export type QueryCheckDocumentArgs = {
  cpf: Scalars['String'];
};


export type QueryGetAllArgs = {
  page_number: Scalars['Float'];
  page_size: Scalars['Float'];
  status?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetCcbPdfArgs = {
  token: Scalars['String'];
};


export type QueryGetLoanDetailsArgs = {
  _id: Scalars['String'];
};


export type QueryGetOptOutShareDataArgs = {
  id: Scalars['String'];
};


export type QueryLoadCcbArgs = {
  _id: Scalars['String'];
};


export type QueryVerifyPixKeyArgs = {
  key: Scalars['String'];
};

export type RelevantOrderResponse = {
  __typename?: 'RelevantOrderResponse';
  data?: Maybe<ReleventOrder>;
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type ReleventOrder = {
  __typename?: 'ReleventOrder';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type RenegotiationCcbDetailsResponse = {
  __typename?: 'RenegotiationCCBDetailsResponse';
  data: CcbResponse;
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  access_token?: Maybe<Scalars['String']>;
  expires_in?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

export type SignCcbResponse = {
  __typename?: 'SignCCBResponse';
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type Signature = {
  fingerprint: Scalars['String'];
  ip_address: Scalars['String'];
  latitude: Scalars['String'];
  longitude: Scalars['String'];
};

export type SimulationRangeResponse = {
  __typename?: 'SimulationRangeResponse';
  has_max_contracts?: Maybe<Scalars['Boolean']>;
  has_salary: Scalars['Boolean'];
  max: Scalars['Float'];
  max_installments?: Maybe<Scalars['Float']>;
  min: Scalars['Float'];
  overdue_installments_total?: Maybe<Scalars['Float']>;
};

export type SimulationRangeResponseWrapper = {
  __typename?: 'SimulationRangeResponseWrapper';
  data?: Maybe<SimulationRangeResponse>;
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type SimulationResponse = {
  __typename?: 'SimulationResponse';
  has_insurance: Scalars['Boolean'];
  installment_amount: Scalars['Float'];
  installment_value: Scalars['Float'];
};

export type SimulationResponseWrapper = {
  __typename?: 'SimulationResponseWrapper';
  data?: Maybe<Array<SimulationResponse>>;
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type Statistic = {
  __typename?: 'Statistic';
  borrowed_value?: Maybe<Scalars['Float']>;
  max_installments_amount?: Maybe<Scalars['Float']>;
  max_installments_value?: Maybe<Scalars['Float']>;
  net_salary?: Maybe<Scalars['Float']>;
  waiting_approval_value?: Maybe<Scalars['Float']>;
};

export type StatisticResponse = {
  __typename?: 'StatisticResponse';
  data?: Maybe<Statistic>;
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean'];
};

export type UpdateBankAccountResponse = {
  __typename?: 'UpdateBankAccountResponse';
  account?: Maybe<Scalars['String']>;
  account_type?: Maybe<Scalars['String']>;
  agency?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
  bank_number?: Maybe<Scalars['String']>;
};

export type LoginMutationVariables = Exact<{
  cpf: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', success: boolean, data?: { __typename?: 'LoginResponseData', access_token: string, expires_in: string } | null | undefined, error?: { __typename?: 'ErrorResponseLogin', message: string } | null | undefined } };

export type SignCcbMutationVariables = Exact<{
  id: Scalars['String'];
  fingerprint: Scalars['String'];
}>;


export type SignCcbMutation = { __typename?: 'Mutation', signCCB: { __typename?: 'SignCCBResponse', success: boolean, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type ForgotPasswordMutationVariables = Exact<{
  cpf: Scalars['String'];
  partner_pathname: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordResponse', email: string, phone: string } };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
  confirm_password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordResponse', message?: string | null | undefined, access_token?: string | null | undefined, expires_in?: string | null | undefined } };

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String'];
  cpf: Scalars['String'];
  confirm_password: Scalars['String'];
  new_password: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'ChangePasswordResponse', message?: string | null | undefined } };

export type CreateOrderMutationVariables = Exact<{
  has_insurance: Scalars['Boolean'];
  installment_amount: Scalars['Float'];
  value: Scalars['Float'];
  reasons: Array<Scalars['String']> | Scalars['String'];
  another_reason: Scalars['String'];
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'CreateOrderWrapper', success: boolean, data?: { __typename?: 'CreateOrderResponse', id?: string | null | undefined } | null | undefined, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type UpdateOrderMutationVariables = Exact<{
  id: Scalars['String'];
  has_insurance: Scalars['Boolean'];
  installment_amount: Scalars['Float'];
  value: Scalars['Float'];
  reasons: Array<Scalars['String']> | Scalars['String'];
  another_reason: Scalars['String'];
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'CreateOrderResponse', id?: string | null | undefined } };

export type UpdateEmployeeMutationVariables = Exact<{
  employee: EmployeeDetailsInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'SuccessResponse', success: boolean, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type FirstAccessMutationVariables = Exact<{
  cpf: Scalars['String'];
  password: Scalars['String'];
  confirm_password: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
}>;


export type FirstAccessMutation = { __typename?: 'Mutation', firstAccess: { __typename?: 'FirstAccessResponse', access_token?: string | null | undefined, expires_in?: string | null | undefined, token_type?: string | null | undefined, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type CreatePreRegistrationMutationVariables = Exact<{
  phone: Scalars['String'];
  pre_registration: PreRegistrationDetailsInput;
}>;


export type CreatePreRegistrationMutation = { __typename?: 'Mutation', createPreRegistration: { __typename?: 'SuccessResponse', success: boolean, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type UpdateOrderDocumentsMutationVariables = Exact<{
  id: Scalars['String'];
  identification_back: Scalars['String'];
  identification_front: Scalars['String'];
  pay_slip: Scalars['String'];
  proof_of_residence: Scalars['String'];
}>;


export type UpdateOrderDocumentsMutation = { __typename?: 'Mutation', updateOrderDocuments: { __typename?: 'SuccessResponse', success: boolean } };

export type UpdateOrderDocumentsV2MutationVariables = Exact<{
  id: Scalars['String'];
  documents: Array<Documents> | Documents;
}>;


export type UpdateOrderDocumentsV2Mutation = { __typename?: 'Mutation', updateOrderDocumentsV2: { __typename?: 'SuccessResponse', success: boolean } };

export type OrderConfirmMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrderConfirmMutation = { __typename?: 'Mutation', orderConfirm: { __typename?: 'SuccessResponse', success: boolean } };

export type DataReviewMutationVariables = Exact<{
  id: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  bank_account: BankAccount;
}>;


export type DataReviewMutation = { __typename?: 'Mutation', dataReview: { __typename?: 'SuccessResponse', success: boolean, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type GetSimulationMutationVariables = Exact<{
  value: Scalars['Float'];
  has_insurance: Scalars['Boolean'];
}>;


export type GetSimulationMutation = { __typename?: 'Mutation', getSimulation: { __typename?: 'SimulationResponseWrapper', success: boolean, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined, data?: Array<{ __typename?: 'SimulationResponse', installment_amount: number, installment_value: number, has_insurance: boolean }> | null | undefined } };

export type SignMutationVariables = Exact<{
  id: Scalars['String'];
  signature: Signature;
}>;


export type SignMutation = { __typename?: 'Mutation', sign: { __typename?: 'SuccessResponse', success: boolean, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type CancelLoanMutationVariables = Exact<{
  id: Scalars['String'];
  reason: Scalars['String'];
}>;


export type CancelLoanMutation = { __typename?: 'Mutation', cancelLoan: { __typename?: 'LoanWrapper', success: boolean, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type RegisterExternalLeadMutationVariables = Exact<{
  name: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
  company: Scalars['String'];
}>;


export type RegisterExternalLeadMutation = { __typename?: 'Mutation', registerExternalLead: { __typename?: 'SuccessResponse', success: boolean, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type UpdateOptOutShareDataMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UpdateOptOutShareDataMutation = { __typename?: 'Mutation', updateOptOutShareData: { __typename?: 'SuccessResponse', success: boolean, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', getMe: { __typename?: 'MeResponse', name: string, company_name: string, position?: string | null | undefined, corporation_cnpj: string } };

export type GetRelevantOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRelevantOrderQuery = { __typename?: 'Query', getRelevantOrder: { __typename?: 'RelevantOrderResponse', success: boolean, data?: { __typename?: 'ReleventOrder', code?: string | null | undefined, id?: string | null | undefined, status?: string | null | undefined } | null | undefined, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type GetCcbPdfQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetCcbPdfQuery = { __typename?: 'Query', getCCBPdf: { __typename?: 'RenegotiationCCBDetailsResponse', success: boolean, data: { __typename?: 'CCBResponse', ccb_url: string, _id: string }, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type GetBanksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBanksQuery = { __typename?: 'Query', getBanks: { __typename?: 'BankResponseWrapper', success: boolean, data?: Array<{ __typename?: 'BankResponse', code: string, name: string }> | null | undefined, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type CheckDocumentQueryVariables = Exact<{
  cpf: Scalars['String'];
}>;


export type CheckDocumentQuery = { __typename?: 'Query', checkDocument: { __typename?: 'DocumentCheckResponse', status: DocumentStatus } };

export type GetAllQueryVariables = Exact<{
  status: Array<Scalars['String']> | Scalars['String'];
  page_size: Scalars['Float'];
  page_number: Scalars['Float'];
}>;


export type GetAllQuery = { __typename?: 'Query', getAll: Array<{ __typename?: 'ListResponse', status: string, ccb_number: string, id: string, installment_value: number, installments_total: number, code: number, installment_amount: number, value: number, created_at: string, corporation_name: string, installments?: Array<{ __typename?: 'InstallmentsResponse', value: number, payment_status: string }> | null | undefined }> };

export type GetSimulationRangeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSimulationRangeQuery = { __typename?: 'Query', getSimulationRange: { __typename?: 'SimulationRangeResponseWrapper', data?: { __typename?: 'SimulationRangeResponse', max: number, min: number, max_installments?: number | null | undefined, has_salary: boolean, overdue_installments_total?: number | null | undefined, has_max_contracts?: boolean | null | undefined } | null | undefined, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type GetEmployeeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeeQuery = { __typename?: 'Query', getEmployee: { __typename?: 'EmployeeResponse', name?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, cpf?: string | null | undefined, gender?: string | null | undefined, bank_account?: { __typename?: 'BankAccountResponse', bank_number?: string | null | undefined, bank_name?: string | null | undefined, agency?: string | null | undefined, account?: string | null | undefined, account_type?: string | null | undefined } | null | undefined, address?: { __typename?: 'AddressResponse', city?: string | null | undefined, complement?: string | null | undefined, district?: string | null | undefined, number?: string | null | undefined, state?: string | null | undefined, street?: string | null | undefined, zip_code?: string | null | undefined } | null | undefined } };

export type GetLoanDetailsQueryVariables = Exact<{
  _id: Scalars['String'];
}>;


export type GetLoanDetailsQuery = { __typename?: 'Query', getLoanDetails: { __typename?: 'LoanWrapper', data?: { __typename?: 'Loan', signed_date?: string | null | undefined, paid_date?: string | null | undefined, has_insurance: boolean, installments_total: number, installment_value: number, installment_amount: number, monthly_interest_rate: number, value: number, created_at: string, status: string, ccb_url?: string | null | undefined, another_reason?: string | null | undefined, reasons?: Array<string> | null | undefined, code: number, installments?: Array<{ __typename?: 'Installment', id?: string | null | undefined, value?: number | null | undefined, interest?: number | null | undefined, amortization?: number | null | undefined, principal_balance?: number | null | undefined, payment_status?: string | null | undefined, number?: number | null | undefined, due_date?: string | null | undefined }> | null | undefined, document?: { __typename?: 'DocumentDetails', insurance?: string | null | undefined, insurance_receipt?: string | null | undefined, identification_back?: string | null | undefined, identification_front?: string | null | undefined, identification_type?: string | null | undefined, pay_slip?: string | null | undefined, proof_of_residence?: string | null | undefined, payment_receipt?: string | null | undefined, debt_payment_receipt?: string | null | undefined } | null | undefined, employee: { __typename?: 'Employee', auth_id: string, full_name: string, email?: string | null | undefined, cell_phone?: string | null | undefined, cpf: string, gender?: string | null | undefined, bank_account?: { __typename?: 'BankDetails', bank_code?: string | null | undefined, bank_name?: string | null | undefined, agency?: string | null | undefined, account?: string | null | undefined, account_type?: string | null | undefined } | null | undefined, address?: { __typename?: 'AddressDetails', city?: string | null | undefined, complement?: string | null | undefined, district?: string | null | undefined, number?: string | null | undefined, zip_code?: string | null | undefined, state?: string | null | undefined, street?: string | null | undefined } | null | undefined } } | null | undefined } };

export type LoadCcbQueryVariables = Exact<{
  _id: Scalars['String'];
}>;


export type LoadCcbQuery = { __typename?: 'Query', loadCcb: { __typename?: 'LoanWrapper', data?: { __typename?: 'Loan', value: number, created_at: string, ccb_url?: string | null | undefined, document?: { __typename?: 'DocumentDetails', insurance?: string | null | undefined } | null | undefined, employee: { __typename?: 'Employee', bank_account?: { __typename?: 'BankDetails', bank_code?: string | null | undefined, bank_name?: string | null | undefined, agency?: string | null | undefined, account?: string | null | undefined, account_type?: string | null | undefined } | null | undefined } } | null | undefined } };

export type GetStatisticQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatisticQuery = { __typename?: 'Query', getStatistic: { __typename?: 'StatisticResponse', success: boolean, data?: { __typename?: 'Statistic', borrowed_value?: number | null | undefined, max_installments_amount?: number | null | undefined, max_installments_value?: number | null | undefined, waiting_approval_value?: number | null | undefined } | null | undefined, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };

export type GetOptOutShareDataQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOptOutShareDataQuery = { __typename?: 'Query', getOptOutShareData: { __typename?: 'OptOutShareDataResponse', success: boolean, data?: { __typename?: 'OptOutShareData', opt_out_share_data?: string | null | undefined } | null | undefined, error?: { __typename?: 'ErrorResponse', message: string } | null | undefined } };


export const LoginDocument = gql`
    mutation login($cpf: String!, $password: String!) {
  login(cpf: $cpf, password: $password) {
    data {
      access_token
      expires_in
    }
    error {
      message
    }
    success
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      cpf: // value for 'cpf'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const SignCcbDocument = gql`
    mutation signCCB($id: String!, $fingerprint: String!) {
  signCCB(id: $id, fingerprint: $fingerprint) {
    error {
      message
    }
    success
  }
}
    `;
export type SignCcbMutationFn = Apollo.MutationFunction<SignCcbMutation, SignCcbMutationVariables>;

/**
 * __useSignCcbMutation__
 *
 * To run a mutation, you first call `useSignCcbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignCcbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signCcbMutation, { data, loading, error }] = useSignCcbMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fingerprint: // value for 'fingerprint'
 *   },
 * });
 */
export function useSignCcbMutation(baseOptions?: Apollo.MutationHookOptions<SignCcbMutation, SignCcbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignCcbMutation, SignCcbMutationVariables>(SignCcbDocument, options);
      }
export type SignCcbMutationHookResult = ReturnType<typeof useSignCcbMutation>;
export type SignCcbMutationResult = Apollo.MutationResult<SignCcbMutation>;
export type SignCcbMutationOptions = Apollo.BaseMutationOptions<SignCcbMutation, SignCcbMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($cpf: String!, $partner_pathname: String!) {
  forgotPassword(cpf: $cpf, partner_pathname: $partner_pathname) {
    email
    phone
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      cpf: // value for 'cpf'
 *      partner_pathname: // value for 'partner_pathname'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($token: String!, $password: String!, $confirm_password: String!) {
  resetPassword(
    token: $token
    password: $password
    confirm_password: $confirm_password
  ) {
    message
    access_token
    expires_in
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *      confirm_password: // value for 'confirm_password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($password: String!, $cpf: String!, $confirm_password: String!, $new_password: String!) {
  changePassword(
    cpf: $cpf
    password: $password
    confirm_password: $confirm_password
    new_password: $new_password
  ) {
    message
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      cpf: // value for 'cpf'
 *      confirm_password: // value for 'confirm_password'
 *      new_password: // value for 'new_password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CreateOrderDocument = gql`
    mutation createOrder($has_insurance: Boolean!, $installment_amount: Float!, $value: Float!, $reasons: [String!]!, $another_reason: String!) {
  createOrder(
    has_insurance: $has_insurance
    installment_amount: $installment_amount
    value: $value
    reasons: $reasons
    another_reason: $another_reason
  ) {
    data {
      id
    }
    success
    error {
      message
    }
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      has_insurance: // value for 'has_insurance'
 *      installment_amount: // value for 'installment_amount'
 *      value: // value for 'value'
 *      reasons: // value for 'reasons'
 *      another_reason: // value for 'another_reason'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation updateOrder($id: String!, $has_insurance: Boolean!, $installment_amount: Float!, $value: Float!, $reasons: [String!]!, $another_reason: String!) {
  updateOrder(
    id: $id
    has_insurance: $has_insurance
    installment_amount: $installment_amount
    value: $value
    reasons: $reasons
    another_reason: $another_reason
  ) {
    id
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      has_insurance: // value for 'has_insurance'
 *      installment_amount: // value for 'installment_amount'
 *      value: // value for 'value'
 *      reasons: // value for 'reasons'
 *      another_reason: // value for 'another_reason'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation updateEmployee($employee: EmployeeDetailsInput!) {
  updateEmployee(employee: $employee) {
    success
    error {
      message
    }
  }
}
    `;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      employee: // value for 'employee'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const FirstAccessDocument = gql`
    mutation firstAccess($cpf: String!, $password: String!, $confirm_password: String!, $email: String!, $phone: String!) {
  firstAccess(
    cpf: $cpf
    password: $password
    confirm_password: $confirm_password
    email: $email
    phone: $phone
  ) {
    access_token
    expires_in
    token_type
    error {
      message
    }
  }
}
    `;
export type FirstAccessMutationFn = Apollo.MutationFunction<FirstAccessMutation, FirstAccessMutationVariables>;

/**
 * __useFirstAccessMutation__
 *
 * To run a mutation, you first call `useFirstAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFirstAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [firstAccessMutation, { data, loading, error }] = useFirstAccessMutation({
 *   variables: {
 *      cpf: // value for 'cpf'
 *      password: // value for 'password'
 *      confirm_password: // value for 'confirm_password'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useFirstAccessMutation(baseOptions?: Apollo.MutationHookOptions<FirstAccessMutation, FirstAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FirstAccessMutation, FirstAccessMutationVariables>(FirstAccessDocument, options);
      }
export type FirstAccessMutationHookResult = ReturnType<typeof useFirstAccessMutation>;
export type FirstAccessMutationResult = Apollo.MutationResult<FirstAccessMutation>;
export type FirstAccessMutationOptions = Apollo.BaseMutationOptions<FirstAccessMutation, FirstAccessMutationVariables>;
export const CreatePreRegistrationDocument = gql`
    mutation createPreRegistration($phone: String!, $pre_registration: PreRegistrationDetailsInput!) {
  createPreRegistration(phone: $phone, pre_registration: $pre_registration) {
    error {
      message
    }
    success
  }
}
    `;
export type CreatePreRegistrationMutationFn = Apollo.MutationFunction<CreatePreRegistrationMutation, CreatePreRegistrationMutationVariables>;

/**
 * __useCreatePreRegistrationMutation__
 *
 * To run a mutation, you first call `useCreatePreRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreRegistrationMutation, { data, loading, error }] = useCreatePreRegistrationMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      pre_registration: // value for 'pre_registration'
 *   },
 * });
 */
export function useCreatePreRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreRegistrationMutation, CreatePreRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreRegistrationMutation, CreatePreRegistrationMutationVariables>(CreatePreRegistrationDocument, options);
      }
export type CreatePreRegistrationMutationHookResult = ReturnType<typeof useCreatePreRegistrationMutation>;
export type CreatePreRegistrationMutationResult = Apollo.MutationResult<CreatePreRegistrationMutation>;
export type CreatePreRegistrationMutationOptions = Apollo.BaseMutationOptions<CreatePreRegistrationMutation, CreatePreRegistrationMutationVariables>;
export const UpdateOrderDocumentsDocument = gql`
    mutation updateOrderDocuments($id: String!, $identification_back: String!, $identification_front: String!, $pay_slip: String!, $proof_of_residence: String!) {
  updateOrderDocuments(
    id: $id
    identification_back: $identification_back
    identification_front: $identification_front
    pay_slip: $pay_slip
    proof_of_residence: $proof_of_residence
  ) {
    success
  }
}
    `;
export type UpdateOrderDocumentsMutationFn = Apollo.MutationFunction<UpdateOrderDocumentsMutation, UpdateOrderDocumentsMutationVariables>;

/**
 * __useUpdateOrderDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateOrderDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderDocumentsMutation, { data, loading, error }] = useUpdateOrderDocumentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      identification_back: // value for 'identification_back'
 *      identification_front: // value for 'identification_front'
 *      pay_slip: // value for 'pay_slip'
 *      proof_of_residence: // value for 'proof_of_residence'
 *   },
 * });
 */
export function useUpdateOrderDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderDocumentsMutation, UpdateOrderDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderDocumentsMutation, UpdateOrderDocumentsMutationVariables>(UpdateOrderDocumentsDocument, options);
      }
export type UpdateOrderDocumentsMutationHookResult = ReturnType<typeof useUpdateOrderDocumentsMutation>;
export type UpdateOrderDocumentsMutationResult = Apollo.MutationResult<UpdateOrderDocumentsMutation>;
export type UpdateOrderDocumentsMutationOptions = Apollo.BaseMutationOptions<UpdateOrderDocumentsMutation, UpdateOrderDocumentsMutationVariables>;
export const UpdateOrderDocumentsV2Document = gql`
    mutation updateOrderDocumentsV2($id: String!, $documents: [Documents!]!) {
  updateOrderDocumentsV2(id: $id, documents: $documents) {
    success
  }
}
    `;
export type UpdateOrderDocumentsV2MutationFn = Apollo.MutationFunction<UpdateOrderDocumentsV2Mutation, UpdateOrderDocumentsV2MutationVariables>;

/**
 * __useUpdateOrderDocumentsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateOrderDocumentsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderDocumentsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderDocumentsV2Mutation, { data, loading, error }] = useUpdateOrderDocumentsV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useUpdateOrderDocumentsV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderDocumentsV2Mutation, UpdateOrderDocumentsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderDocumentsV2Mutation, UpdateOrderDocumentsV2MutationVariables>(UpdateOrderDocumentsV2Document, options);
      }
export type UpdateOrderDocumentsV2MutationHookResult = ReturnType<typeof useUpdateOrderDocumentsV2Mutation>;
export type UpdateOrderDocumentsV2MutationResult = Apollo.MutationResult<UpdateOrderDocumentsV2Mutation>;
export type UpdateOrderDocumentsV2MutationOptions = Apollo.BaseMutationOptions<UpdateOrderDocumentsV2Mutation, UpdateOrderDocumentsV2MutationVariables>;
export const OrderConfirmDocument = gql`
    mutation orderConfirm($id: String!) {
  orderConfirm(id: $id) {
    success
  }
}
    `;
export type OrderConfirmMutationFn = Apollo.MutationFunction<OrderConfirmMutation, OrderConfirmMutationVariables>;

/**
 * __useOrderConfirmMutation__
 *
 * To run a mutation, you first call `useOrderConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderConfirmMutation, { data, loading, error }] = useOrderConfirmMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderConfirmMutation(baseOptions?: Apollo.MutationHookOptions<OrderConfirmMutation, OrderConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderConfirmMutation, OrderConfirmMutationVariables>(OrderConfirmDocument, options);
      }
export type OrderConfirmMutationHookResult = ReturnType<typeof useOrderConfirmMutation>;
export type OrderConfirmMutationResult = Apollo.MutationResult<OrderConfirmMutation>;
export type OrderConfirmMutationOptions = Apollo.BaseMutationOptions<OrderConfirmMutation, OrderConfirmMutationVariables>;
export const DataReviewDocument = gql`
    mutation dataReview($id: String!, $email: String!, $phone: String!, $bank_account: BankAccount!) {
  dataReview(id: $id, email: $email, phone: $phone, bank_account: $bank_account) {
    success
    error {
      message
    }
  }
}
    `;
export type DataReviewMutationFn = Apollo.MutationFunction<DataReviewMutation, DataReviewMutationVariables>;

/**
 * __useDataReviewMutation__
 *
 * To run a mutation, you first call `useDataReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataReviewMutation, { data, loading, error }] = useDataReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      bank_account: // value for 'bank_account'
 *   },
 * });
 */
export function useDataReviewMutation(baseOptions?: Apollo.MutationHookOptions<DataReviewMutation, DataReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataReviewMutation, DataReviewMutationVariables>(DataReviewDocument, options);
      }
export type DataReviewMutationHookResult = ReturnType<typeof useDataReviewMutation>;
export type DataReviewMutationResult = Apollo.MutationResult<DataReviewMutation>;
export type DataReviewMutationOptions = Apollo.BaseMutationOptions<DataReviewMutation, DataReviewMutationVariables>;
export const GetSimulationDocument = gql`
    mutation getSimulation($value: Float!, $has_insurance: Boolean!) {
  getSimulation(value: $value, has_insurance: $has_insurance) {
    success
    error {
      message
    }
    data {
      installment_amount
      installment_value
      has_insurance
    }
  }
}
    `;
export type GetSimulationMutationFn = Apollo.MutationFunction<GetSimulationMutation, GetSimulationMutationVariables>;

/**
 * __useGetSimulationMutation__
 *
 * To run a mutation, you first call `useGetSimulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSimulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSimulationMutation, { data, loading, error }] = useGetSimulationMutation({
 *   variables: {
 *      value: // value for 'value'
 *      has_insurance: // value for 'has_insurance'
 *   },
 * });
 */
export function useGetSimulationMutation(baseOptions?: Apollo.MutationHookOptions<GetSimulationMutation, GetSimulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetSimulationMutation, GetSimulationMutationVariables>(GetSimulationDocument, options);
      }
export type GetSimulationMutationHookResult = ReturnType<typeof useGetSimulationMutation>;
export type GetSimulationMutationResult = Apollo.MutationResult<GetSimulationMutation>;
export type GetSimulationMutationOptions = Apollo.BaseMutationOptions<GetSimulationMutation, GetSimulationMutationVariables>;
export const SignDocument = gql`
    mutation sign($id: String!, $signature: Signature!) {
  sign(id: $id, signature: $signature) {
    success
    error {
      message
    }
  }
}
    `;
export type SignMutationFn = Apollo.MutationFunction<SignMutation, SignMutationVariables>;

/**
 * __useSignMutation__
 *
 * To run a mutation, you first call `useSignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signMutation, { data, loading, error }] = useSignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useSignMutation(baseOptions?: Apollo.MutationHookOptions<SignMutation, SignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignMutation, SignMutationVariables>(SignDocument, options);
      }
export type SignMutationHookResult = ReturnType<typeof useSignMutation>;
export type SignMutationResult = Apollo.MutationResult<SignMutation>;
export type SignMutationOptions = Apollo.BaseMutationOptions<SignMutation, SignMutationVariables>;
export const CancelLoanDocument = gql`
    mutation cancelLoan($id: String!, $reason: String!) {
  cancelLoan(id: $id, reason: $reason) {
    success
    error {
      message
    }
  }
}
    `;
export type CancelLoanMutationFn = Apollo.MutationFunction<CancelLoanMutation, CancelLoanMutationVariables>;

/**
 * __useCancelLoanMutation__
 *
 * To run a mutation, you first call `useCancelLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelLoanMutation, { data, loading, error }] = useCancelLoanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelLoanMutation(baseOptions?: Apollo.MutationHookOptions<CancelLoanMutation, CancelLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelLoanMutation, CancelLoanMutationVariables>(CancelLoanDocument, options);
      }
export type CancelLoanMutationHookResult = ReturnType<typeof useCancelLoanMutation>;
export type CancelLoanMutationResult = Apollo.MutationResult<CancelLoanMutation>;
export type CancelLoanMutationOptions = Apollo.BaseMutationOptions<CancelLoanMutation, CancelLoanMutationVariables>;
export const RegisterExternalLeadDocument = gql`
    mutation registerExternalLead($name: String!, $phone: String!, $email: String!, $company: String!) {
  registerExternalLead(
    name: $name
    phone: $phone
    email: $email
    company: $company
  ) {
    success
    error {
      message
    }
  }
}
    `;
export type RegisterExternalLeadMutationFn = Apollo.MutationFunction<RegisterExternalLeadMutation, RegisterExternalLeadMutationVariables>;

/**
 * __useRegisterExternalLeadMutation__
 *
 * To run a mutation, you first call `useRegisterExternalLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterExternalLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerExternalLeadMutation, { data, loading, error }] = useRegisterExternalLeadMutation({
 *   variables: {
 *      name: // value for 'name'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      company: // value for 'company'
 *   },
 * });
 */
export function useRegisterExternalLeadMutation(baseOptions?: Apollo.MutationHookOptions<RegisterExternalLeadMutation, RegisterExternalLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterExternalLeadMutation, RegisterExternalLeadMutationVariables>(RegisterExternalLeadDocument, options);
      }
export type RegisterExternalLeadMutationHookResult = ReturnType<typeof useRegisterExternalLeadMutation>;
export type RegisterExternalLeadMutationResult = Apollo.MutationResult<RegisterExternalLeadMutation>;
export type RegisterExternalLeadMutationOptions = Apollo.BaseMutationOptions<RegisterExternalLeadMutation, RegisterExternalLeadMutationVariables>;
export const UpdateOptOutShareDataDocument = gql`
    mutation updateOptOutShareData($id: String!) {
  updateOptOutShareData(id: $id) {
    success
    error {
      message
    }
  }
}
    `;
export type UpdateOptOutShareDataMutationFn = Apollo.MutationFunction<UpdateOptOutShareDataMutation, UpdateOptOutShareDataMutationVariables>;

/**
 * __useUpdateOptOutShareDataMutation__
 *
 * To run a mutation, you first call `useUpdateOptOutShareDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptOutShareDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptOutShareDataMutation, { data, loading, error }] = useUpdateOptOutShareDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOptOutShareDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOptOutShareDataMutation, UpdateOptOutShareDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOptOutShareDataMutation, UpdateOptOutShareDataMutationVariables>(UpdateOptOutShareDataDocument, options);
      }
export type UpdateOptOutShareDataMutationHookResult = ReturnType<typeof useUpdateOptOutShareDataMutation>;
export type UpdateOptOutShareDataMutationResult = Apollo.MutationResult<UpdateOptOutShareDataMutation>;
export type UpdateOptOutShareDataMutationOptions = Apollo.BaseMutationOptions<UpdateOptOutShareDataMutation, UpdateOptOutShareDataMutationVariables>;
export const GetMeDocument = gql`
    query getMe {
  getMe {
    name
    company_name
    position
    corporation_cnpj
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetRelevantOrderDocument = gql`
    query getRelevantOrder {
  getRelevantOrder {
    data {
      code
      id
      status
    }
    success
    error {
      message
    }
  }
}
    `;

/**
 * __useGetRelevantOrderQuery__
 *
 * To run a query within a React component, call `useGetRelevantOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelevantOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelevantOrderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRelevantOrderQuery(baseOptions?: Apollo.QueryHookOptions<GetRelevantOrderQuery, GetRelevantOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelevantOrderQuery, GetRelevantOrderQueryVariables>(GetRelevantOrderDocument, options);
      }
export function useGetRelevantOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelevantOrderQuery, GetRelevantOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelevantOrderQuery, GetRelevantOrderQueryVariables>(GetRelevantOrderDocument, options);
        }
export type GetRelevantOrderQueryHookResult = ReturnType<typeof useGetRelevantOrderQuery>;
export type GetRelevantOrderLazyQueryHookResult = ReturnType<typeof useGetRelevantOrderLazyQuery>;
export type GetRelevantOrderQueryResult = Apollo.QueryResult<GetRelevantOrderQuery, GetRelevantOrderQueryVariables>;
export const GetCcbPdfDocument = gql`
    query getCCBPdf($token: String!) {
  getCCBPdf(token: $token) {
    data {
      ccb_url
      _id
    }
    success
    error {
      message
    }
  }
}
    `;

/**
 * __useGetCcbPdfQuery__
 *
 * To run a query within a React component, call `useGetCcbPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCcbPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCcbPdfQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetCcbPdfQuery(baseOptions: Apollo.QueryHookOptions<GetCcbPdfQuery, GetCcbPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCcbPdfQuery, GetCcbPdfQueryVariables>(GetCcbPdfDocument, options);
      }
export function useGetCcbPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCcbPdfQuery, GetCcbPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCcbPdfQuery, GetCcbPdfQueryVariables>(GetCcbPdfDocument, options);
        }
export type GetCcbPdfQueryHookResult = ReturnType<typeof useGetCcbPdfQuery>;
export type GetCcbPdfLazyQueryHookResult = ReturnType<typeof useGetCcbPdfLazyQuery>;
export type GetCcbPdfQueryResult = Apollo.QueryResult<GetCcbPdfQuery, GetCcbPdfQueryVariables>;
export const GetBanksDocument = gql`
    query getBanks {
  getBanks {
    data {
      code
      name
    }
    success
    error {
      message
    }
  }
}
    `;

/**
 * __useGetBanksQuery__
 *
 * To run a query within a React component, call `useGetBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBanksQuery(baseOptions?: Apollo.QueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
      }
export function useGetBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
        }
export type GetBanksQueryHookResult = ReturnType<typeof useGetBanksQuery>;
export type GetBanksLazyQueryHookResult = ReturnType<typeof useGetBanksLazyQuery>;
export type GetBanksQueryResult = Apollo.QueryResult<GetBanksQuery, GetBanksQueryVariables>;
export const CheckDocumentDocument = gql`
    query checkDocument($cpf: String!) {
  checkDocument(cpf: $cpf) {
    status
  }
}
    `;

/**
 * __useCheckDocumentQuery__
 *
 * To run a query within a React component, call `useCheckDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDocumentQuery({
 *   variables: {
 *      cpf: // value for 'cpf'
 *   },
 * });
 */
export function useCheckDocumentQuery(baseOptions: Apollo.QueryHookOptions<CheckDocumentQuery, CheckDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckDocumentQuery, CheckDocumentQueryVariables>(CheckDocumentDocument, options);
      }
export function useCheckDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckDocumentQuery, CheckDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckDocumentQuery, CheckDocumentQueryVariables>(CheckDocumentDocument, options);
        }
export type CheckDocumentQueryHookResult = ReturnType<typeof useCheckDocumentQuery>;
export type CheckDocumentLazyQueryHookResult = ReturnType<typeof useCheckDocumentLazyQuery>;
export type CheckDocumentQueryResult = Apollo.QueryResult<CheckDocumentQuery, CheckDocumentQueryVariables>;
export const GetAllDocument = gql`
    query getAll($status: [String!]!, $page_size: Float!, $page_number: Float!) {
  getAll(status: $status, page_size: $page_size, page_number: $page_number) {
    status
    ccb_number
    id
    installment_value
    installments_total
    code
    installments {
      value
      payment_status
    }
    installment_amount
    value
    created_at
    corporation_name
  }
}
    `;

/**
 * __useGetAllQuery__
 *
 * To run a query within a React component, call `useGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllQuery({
 *   variables: {
 *      status: // value for 'status'
 *      page_size: // value for 'page_size'
 *      page_number: // value for 'page_number'
 *   },
 * });
 */
export function useGetAllQuery(baseOptions: Apollo.QueryHookOptions<GetAllQuery, GetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllQuery, GetAllQueryVariables>(GetAllDocument, options);
      }
export function useGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllQuery, GetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllQuery, GetAllQueryVariables>(GetAllDocument, options);
        }
export type GetAllQueryHookResult = ReturnType<typeof useGetAllQuery>;
export type GetAllLazyQueryHookResult = ReturnType<typeof useGetAllLazyQuery>;
export type GetAllQueryResult = Apollo.QueryResult<GetAllQuery, GetAllQueryVariables>;
export const GetSimulationRangeDocument = gql`
    query getSimulationRange {
  getSimulationRange {
    data {
      max
      min
      max_installments
      has_salary
      overdue_installments_total
      has_max_contracts
    }
    error {
      message
    }
  }
}
    `;

/**
 * __useGetSimulationRangeQuery__
 *
 * To run a query within a React component, call `useGetSimulationRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimulationRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimulationRangeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSimulationRangeQuery(baseOptions?: Apollo.QueryHookOptions<GetSimulationRangeQuery, GetSimulationRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimulationRangeQuery, GetSimulationRangeQueryVariables>(GetSimulationRangeDocument, options);
      }
export function useGetSimulationRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimulationRangeQuery, GetSimulationRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimulationRangeQuery, GetSimulationRangeQueryVariables>(GetSimulationRangeDocument, options);
        }
export type GetSimulationRangeQueryHookResult = ReturnType<typeof useGetSimulationRangeQuery>;
export type GetSimulationRangeLazyQueryHookResult = ReturnType<typeof useGetSimulationRangeLazyQuery>;
export type GetSimulationRangeQueryResult = Apollo.QueryResult<GetSimulationRangeQuery, GetSimulationRangeQueryVariables>;
export const GetEmployeeDocument = gql`
    query getEmployee {
  getEmployee {
    name
    email
    phone
    cpf
    gender
    bank_account {
      bank_number
      bank_name
      agency
      account
      account_type
    }
    address {
      city
      complement
      district
      number
      state
      street
      zip_code
    }
  }
}
    `;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetLoanDetailsDocument = gql`
    query getLoanDetails($_id: String!) {
  getLoanDetails(_id: $_id) {
    data {
      signed_date
      paid_date
      has_insurance
      installments_total
      installment_value
      installment_amount
      installments {
        id
        value
        interest
        amortization
        principal_balance
        payment_status
        number
        due_date
      }
      monthly_interest_rate
      value
      created_at
      status
      ccb_url
      another_reason
      reasons
      code
      document {
        insurance
        insurance_receipt
        identification_back
        identification_front
        identification_type
        pay_slip
        proof_of_residence
        payment_receipt
        debt_payment_receipt
      }
      employee {
        auth_id
        full_name
        email
        cell_phone
        cpf
        gender
        bank_account {
          bank_code
          bank_name
          agency
          account
          account_type
        }
        address {
          city
          complement
          district
          number
          zip_code
          state
          street
        }
      }
    }
  }
}
    `;

/**
 * __useGetLoanDetailsQuery__
 *
 * To run a query within a React component, call `useGetLoanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useGetLoanDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLoanDetailsQuery, GetLoanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanDetailsQuery, GetLoanDetailsQueryVariables>(GetLoanDetailsDocument, options);
      }
export function useGetLoanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanDetailsQuery, GetLoanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanDetailsQuery, GetLoanDetailsQueryVariables>(GetLoanDetailsDocument, options);
        }
export type GetLoanDetailsQueryHookResult = ReturnType<typeof useGetLoanDetailsQuery>;
export type GetLoanDetailsLazyQueryHookResult = ReturnType<typeof useGetLoanDetailsLazyQuery>;
export type GetLoanDetailsQueryResult = Apollo.QueryResult<GetLoanDetailsQuery, GetLoanDetailsQueryVariables>;
export const LoadCcbDocument = gql`
    query loadCcb($_id: String!) {
  loadCcb(_id: $_id) {
    data {
      value
      created_at
      ccb_url
      document {
        insurance
      }
      employee {
        bank_account {
          bank_code
          bank_name
          agency
          account
          account_type
        }
      }
    }
  }
}
    `;

/**
 * __useLoadCcbQuery__
 *
 * To run a query within a React component, call `useLoadCcbQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCcbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCcbQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useLoadCcbQuery(baseOptions: Apollo.QueryHookOptions<LoadCcbQuery, LoadCcbQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadCcbQuery, LoadCcbQueryVariables>(LoadCcbDocument, options);
      }
export function useLoadCcbLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadCcbQuery, LoadCcbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadCcbQuery, LoadCcbQueryVariables>(LoadCcbDocument, options);
        }
export type LoadCcbQueryHookResult = ReturnType<typeof useLoadCcbQuery>;
export type LoadCcbLazyQueryHookResult = ReturnType<typeof useLoadCcbLazyQuery>;
export type LoadCcbQueryResult = Apollo.QueryResult<LoadCcbQuery, LoadCcbQueryVariables>;
export const GetStatisticDocument = gql`
    query getStatistic {
  getStatistic {
    data {
      borrowed_value
      max_installments_amount
      max_installments_value
      waiting_approval_value
    }
    error {
      message
    }
    success
  }
}
    `;

/**
 * __useGetStatisticQuery__
 *
 * To run a query within a React component, call `useGetStatisticQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatisticQuery(baseOptions?: Apollo.QueryHookOptions<GetStatisticQuery, GetStatisticQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatisticQuery, GetStatisticQueryVariables>(GetStatisticDocument, options);
      }
export function useGetStatisticLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatisticQuery, GetStatisticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatisticQuery, GetStatisticQueryVariables>(GetStatisticDocument, options);
        }
export type GetStatisticQueryHookResult = ReturnType<typeof useGetStatisticQuery>;
export type GetStatisticLazyQueryHookResult = ReturnType<typeof useGetStatisticLazyQuery>;
export type GetStatisticQueryResult = Apollo.QueryResult<GetStatisticQuery, GetStatisticQueryVariables>;
export const GetOptOutShareDataDocument = gql`
    query getOptOutShareData($id: String!) {
  getOptOutShareData(id: $id) {
    data {
      opt_out_share_data
    }
    error {
      message
    }
    success
  }
}
    `;

/**
 * __useGetOptOutShareDataQuery__
 *
 * To run a query within a React component, call `useGetOptOutShareDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptOutShareDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptOutShareDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOptOutShareDataQuery(baseOptions: Apollo.QueryHookOptions<GetOptOutShareDataQuery, GetOptOutShareDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptOutShareDataQuery, GetOptOutShareDataQueryVariables>(GetOptOutShareDataDocument, options);
      }
export function useGetOptOutShareDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOptOutShareDataQuery, GetOptOutShareDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptOutShareDataQuery, GetOptOutShareDataQueryVariables>(GetOptOutShareDataDocument, options);
        }
export type GetOptOutShareDataQueryHookResult = ReturnType<typeof useGetOptOutShareDataQuery>;
export type GetOptOutShareDataLazyQueryHookResult = ReturnType<typeof useGetOptOutShareDataLazyQuery>;
export type GetOptOutShareDataQueryResult = Apollo.QueryResult<GetOptOutShareDataQuery, GetOptOutShareDataQueryVariables>;